module.exports = __webpack_public_path__ + "static/img/640(8).4034637.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/growthThinking/list3/640(8).png
// module id = ZJJX
// module chunks = 1